import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function NotFound() {
  return (
    <section className="min-h-[70vh] flex items-center">
      <div className="mx-auto max-w-[800px] px-5 text-center py-32">
        <p className="overline">404 · Not found</p>
        <h1 className="mt-5 font-display text-6xl sm:text-7xl font-extrabold tracking-tighter">Page not found.</h1>
        <p className="mt-5 text-muted-foreground">The page you're after doesn't exist — or has been moved.</p>
        <Link to="/" data-testid="not-found-home" className="mt-8 inline-flex items-center gap-2 bg-accent text-white px-5 py-3 text-sm font-semibold hover:bg-accent/90">
          <ChevronLeft className="w-4 h-4" /> Back to home
        </Link>
      </div>
    </section>
  );
}
